interface AnnualPlanBottomSheetProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  onExplorePress?: () => void;
  bottomSheetData?: any;
}
import {
  Backdrop,
  Bullet,
  ButtonWrap,
  DragHandleWrap,
  DragHandle,
  FeatureRow,
  Features,
  FeatureText,
  HeaderImage,
  ImageWrap,
  Overlay,
  PrimaryBtn,
  Sheet,
} from "./Styles";
import FormattedText from "../../../FormattedText/FormattedText";

export const AnnualPlanBottomSheet = ({
  visible,
  setVisible,
  onExplorePress,
  bottomSheetData,
}: AnnualPlanBottomSheetProps) => {
  if (!visible) return null;

  const hasImage = Boolean(bottomSheetData?.heading?.img);
  const hasFeatures =
    Array.isArray(bottomSheetData?.list) && bottomSheetData.list.length > 0;
  const hasButton = Boolean(bottomSheetData?.ctaText?.title);

  return (
    <Overlay>
      <Backdrop onClick={() => setVisible?.(false)} aria-label="close annual sheet" />
      <Sheet>
        {hasImage ? (
          <ImageWrap>
            <HeaderImage src={bottomSheetData.heading.img} alt="annual plan" />
            <DragHandleWrap>
              <DragHandle />
            </DragHandleWrap>
          </ImageWrap>
        ) : (
          <DragHandle />
        )}

        {hasFeatures ? (
          <Features>
            {bottomSheetData.list.map((item: any, index: number) => (
              <FeatureRow key={`annual-feature-${index}`}>
                <Bullet />
                <FeatureText>
                  <FormattedText value={item?.title} />
                </FeatureText>
              </FeatureRow>
            ))}
          </Features>
        ) : null}

        {hasButton ? (
          <ButtonWrap>
            <PrimaryBtn onClick={onExplorePress}>
              <FormattedText value={bottomSheetData.ctaText.title} />
            </PrimaryBtn>
          </ButtonWrap>
        ) : null}
      </Sheet>
    </Overlay>
  );
};

